/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Param_RefusedInputs */



/**
* | output |
* | --- |
* | "The server refused a parameter. oneAI no longer sends it to this endpoint." |
*
* @param {Private_Models_Hint_Param_RefusedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_param_refused = /** @type {((inputs?: Private_Models_Hint_Param_RefusedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Param_RefusedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Server hat einen Parameter abgelehnt. oneAI sendet ihn an diesen Endpunkt nicht mehr.")
	return /** @type {LocalizedString} */ ("The server refused a parameter. oneAI no longer sends it to this endpoint.")
});